import { Check } from '@ankr.com/ui';
import { push } from 'connected-react-router';
import { useCallback } from 'react';

import { chainsRoutesConfig } from 'domains/chains/routes';
import { useAccount } from 'modules/account/hooks/useAccount';
import { useAccountStatus } from 'modules/accountStatus/hooks/useAccountStatus';
import { useAppDispatch } from 'store/useAppDispatch';
import { useAuth } from 'modules/auth/hooks/useAuth';
import { useTranslation } from 'modules/i18n/hooks/useTranslation';

import { PlanButton } from '../PlanButton';
import { freemiumPlanButtonTranslation } from './translation';
import { useFreemiumPlanButtonStyles } from './useFreemiumPlanButtonStyles';

export interface FreemiumPlanButtonProps {
  className?: string;
  isCurrentPlanTextShort?: boolean;
  onClick?: () => void;
}

export const FreemiumPlanButton = ({
  className = '',
  isCurrentPlanTextShort,
  onClick: onClickExternal,
}: FreemiumPlanButtonProps) => {
  const { isLoggedIn } = useAuth();
  const { isFinance } = useAccount();
  const { isFreemium } = useAccountStatus();

  const { classes } = useFreemiumPlanButtonStyles(undefined, {
    props: { classes: { root: className } },
  });

  const { keys, t } = useTranslation(freemiumPlanButtonTranslation);

  const dispatch = useAppDispatch();

  const redirectToChainsPage = useCallback(() => {
    onClickExternal?.();

    const location = chainsRoutesConfig.chains.generatePath({ isLoggedIn });

    dispatch(push(location));
  }, [dispatch, isLoggedIn, onClickExternal]);

  return (
    <PlanButton
      className={classes.root}
      disabled={isLoggedIn}
      isCurrentPlan={isLoggedIn && isFreemium && !isFinance}
      isCurrentPlanTextShort={isCurrentPlanTextShort}
      onClick={redirectToChainsPage}
      startIcon={isFreemium && !isFinance ? <Check /> : undefined}
    >
      {t(keys.startFree)}
    </PlanButton>
  );
};
